/* Blocks: */
export const PARAGRAPH = 'paragraph';
/**
 * @deprecated You can now use the Heading element with level 1 to create headlines.
 */
export const HEADLINE = 'headline';
/**
 * @deprecated You can now use the Heading element with level 2 to create titles.
 */
export const TITLE = 'title';
/**
 * @deprecated You can now use the Heading element with level 3 to create subtitles.
 */
export const SUBTITLE = 'subtitle';
export const HEADING = 'heading';
export const DIVIDER = 'divider';

/* Inlines: */
export const INLINE_CODE = 'inline-code';

/* Marks: */
export const BOLD = 'bold';
export const ITALIC = 'italic';
export const UNDERLINE = 'underline';
export const SPAN = 'span';
export const STRIKETHROUGH = 'strikethrough';
export const COLORED = 'color';
export const SELECTED = 'selected';

/* Others: */
export const UNDO = 'undo';
export const REDO = 'redo';
export const BLOCK_BODY_TYPE_SELECTOR = 'BlockTypeSelector';

/** Available typography toggleable features */
export enum TYPOGRAPHY_FEATURES {
    /** Allow **bold** text mark */
    bold = BOLD,
    /** Allow *italic* text mark */
    italic = ITALIC,
    /** Allow underline text mark */
    underline = UNDERLINE,
    /** Allow color text mark */
    color = COLORED,
    /** Allow ~~strikethrough~~ text mark */
    strikethrough = STRIKETHROUGH,
    /** Allow paragraph element */
    paragraph = PARAGRAPH,
    /**
     * Allow # Heading 1 element
     * @deprecated You can now use the Heading element with level 1 to create headlines.
     */
    headline = HEADLINE,
    /**
     * Allow ## Heading 2 element
     * @deprecated You can now use the Heading element with level 2 to create titles.
     */
    title = TITLE,
    /**
     * Allow ### Heading 3 element
     * @deprecated You can now use the Heading element with level 3 to create subtitles.
     */
    subtitle = SUBTITLE,
    /** Allow Headings element (every levels) */
    heading = HEADING,
    /** Allow --- divider element */
    divider = DIVIDER,
    /** Allow `inline code` element */
    inlineCode = INLINE_CODE,
    /** Allow text alignment */
    alignment = 'alignment',
}
